export enum LocalStorageKeys {
  IsNotNewUser = 'isNotNewUser',
  NotificationsPosition = 'notificationsPosition',
  MediaQuery = 'mediaQuery',
  OneTimeNotifications = 'oneTimeNotifications',
}
